import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import '../Analyze.scss';
import iconCustomReport from '../../../../assets/images/icon_create_custom_report.svg';

import BotCustomReportForm from './Components/BotCustomReportForm';
import BotCustomReportList from './Components/BotCustomReportList';

const BotCustomReport = (props) => {
  const { filter } = props;

  return (
    <div className="container-all-history">
      <div className="container-info-relatorio custom-report-content">
        <div className="custom-report-form-header">
          <div className="custom-report-form-header-title">
            <img src={iconCustomReport} alt="Relatório Customizado" />
            <p className="custom-report-form-header-title-p">
              Criar Relatório Personalizado
            </p>
          </div>
          <p className="custom-report-form-header-subtitle-p">
            Selecione o formato do arquivo, período e campos para gerar o
            relatório.
          </p>
        </div>
        <BotCustomReportForm fileFormat="CSV" />
      </div>

      <BotCustomReportList filter={filter} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(BotCustomReport))
);
